import React from "react";
// UI Frameworks
import { TableCell } from "@mui/material";
import TimelineIcon from "@mui/icons-material/Timeline";
// Common Components
import { Button, Modal } from "src/Components";
// Local Components
import SendManualModal from "./SendManualModal";
// Types
import { GoldPositionTableReport } from "src/Interfaces/goldArbitrage";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import ChartSearchParamUI from "../WatchList/ChartSearchParamUI";

function chartDockTitle(row: object) {
  const named = row as {
    srcInstrumentName?: string;
    destInstrumentName?: string;
  };
  return (
    [named.srcInstrumentName, named.destInstrumentName].filter(Boolean).join(" / ") ||
    "نمودار"
  );
}

const AdditionalHeader = (_props: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell /> <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: GoldPositionTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isChartModalOpen, setIsChartModalOpen] = React.useState(false);

  return (
    <>
      <TableCell>
        {isModalOpen ? (
          <Modal
            UI={
              <SendManualModal
                row={row}
                onClose={() => setIsModalOpen(false)}
                onSuccess={onAction}
              />
            }
            onClose={() => setIsModalOpen(false)}
            modalBoxClassName="!min-w-min !min-h-min"
          />
        ) : null}
        <div className="w-24">
          <Button
            onClick={() => setIsModalOpen(true)}
            text="ارسال دستی"
            variant="contained"
            className="table-btn"
          />
        </div>
      </TableCell>
      <TableCell>
        {isChartModalOpen ? (
          <Modal
            UI={<ChartSearchParamUI row={row} />}
            title={chartDockTitle(row)}
            onClose={() => setIsChartModalOpen(false)}
            fullScreen
          />
        ) : null}
        <div className="w-24">
          <Button
            onClick={() => setIsChartModalOpen(true)}
            text={
              <>
                <TimelineIcon style={{ fontSize: 16, marginLeft: 4 }} />
              </>
            }
            variant="contained"
            className="table-btn"
          />
        </div>
      </TableCell>
    </>
  );
};

export const GoldPositionAdditional: IAdditional<GoldPositionTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
